import { oz } from '@weft/utils';
import { PAYMENT_PROVIDERS } from '../../primitives';

export const InvoicePaymentProviderInformationSchema = oz.object({
  paymentProviderType: oz.nativeEnum(PAYMENT_PROVIDERS),
  externalInvoicePaymentLink: oz.string().optional(),
  externalInvoiceId: oz.string(),
  externalInvoiceStatus: oz.string(),
}).openapi('InvoicePaymentProviderInformation');

export type InvoicePaymentProviderInformation = oz.infer<typeof InvoicePaymentProviderInformationSchema>;